import type Inputmask from 'inputmask'

export const mask: Record<string, Inputmask.Options> = {
  currency: {
    alias: 'currency',
    groupSeparator: ',',
    digits: 0,
    prefix: '',
    placeholder: '',
    numericInput: true,
    inputmode: 'numeric',
    unmaskAsNumber: true,
  },
  numeric: {
    alias: 'numeric',
    digits: 0,
    numericInput: true,
    inputmode: 'numeric',
    unmaskAsNumber: true,
  },
  decimal: {
    alias: 'decimal',
    digits: 2,
    numericInput: true,
    inputmode: 'numeric',
    unmaskAsNumber: true,
  },
  percentage: {
    alias: 'percentage',
    numericInput: true,
    inputmode: 'numeric',
    positionCaretOnClick: 'radixFocus',
    min: 0,
  },
  age: {
    positionCaretOnClick: 'select',
    mask: '9[9]',
    placeholder: '',
    numericInput: true,
    inputmode: 'numeric',
  },
}
